module.exports = __webpack_public_path__ + "img/13.8c613f2b.webp";